import { Component, Inject, OnInit } from "@angular/core";
import { CustomerServiceService } from "../customer-service.service";
import { Router } from "@angular/router";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as _ from "lodash";

@Component({
  selector: "app-customer-cancel-quote",
  templateUrl: "./customer-cancel-quote.component.html",
  styleUrls: ["./customer-cancel-quote.component.css"],
})
export class CustomerCancelQuoteComponent implements OnInit {
  loading: boolean = false;
  token: any;
  item: any;
  trips: any;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  fetch_page: any = 0;
  tripsloading: boolean = false;
  tripType: any = "-1";
  paid_amount: any;
  total_amount: any;
  amount_paid: any;
  balance_amount: any;
  tripNumber: any = -1;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: CustomerServiceService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token");
    this.getTripsDetails(this.tripType, this.tripNumber);
  }

  cancelQuote(item: any) {
    this.loading = true;
    // this.close();
    const cancelQuote = {
      trip_id: item._id,
    };
    this.services.cancelQuote(cancelQuote, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.getTripsDetails(this.tripType, this.tripNumber);
          this.snackBar.open(response.body.message, "Success", {
            duration: 5000,
          });
          // this.onlinePayment(response, this.token, item);
        }
        this.loading = false;
        this.getTripsDetails(this.tripType, this.tripNumber);
      },
      (error: any) => {
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  getTripsDetails(tripType: any, type: any) {
    this.tripsloading = true;
    this.tripNumber = type;
    this.services
      .GetTripList(this.token, this.startPage, tripType, this.tripNumber)
      .subscribe(
        (response: any) => {
          this.trips = response.body.data;
          //added by logan because of hardcoded 0 index payment status is used to diaplay paybalance button on html
          this.trips = _.forEach(this.trips, (item) => {
            item.payment_details = _.filter(item.payment_details, (payItem) => {
              return payItem.payment_status != "not-paid";
            });
          });
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;

          this.tripsloading = false;
          for (let i = 0; i < this.trips.length; i++) {
            for (let j = 0; j < this.trips[i].payment_details.length; j++) {
              if (
                this.trips[i].payment_details[0].payment_status ===
                  "fully-paid" ||
                this.trips[i].payment_details[0].payment_status ===
                  "partial-paid"
              ) {
                if (
                  this.trips[i].trip_status === "tripstarted" ||
                  "trip-booked" ||
                  "inprogress"
                ) {
                  this.trips[i].live_track = true;
                } else {
                  this.trips[i].live_track = false;
                }
              } else {
                this.trips[i].live_track = false;
              }

              this.total_amount =
                this.trips[i].payment_details[j].price_details.total_amount;
              this.paid_amount =
                this.trips[i].payment_details[j].price_details.amount_paid;
              this.balance_amount = this.total_amount - this.paid_amount;
            }
          }
        },

        (error) => {
          this.tripsloading = false;
          this.trips = [];
          if (error.status == 404) {
            this.last_page = 1;
            return;
          }
          if (error.status === 401) {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          return;
        }
      );
  }
}
